import React from "react";
import { AdiccionesDetalleOrdenElementos } from "./AdiccionesDetalleOrdenElementos";
import { AdiccionesCard } from "../UI/AdiccionesCard";

export const AdiccionesDetalleOrden = () => { 

  return (
    <AdiccionesCard width={"55%"}>
      <AdiccionesDetalleOrdenElementos />
    </AdiccionesCard >
  );
};
